import React from 'react';
import SuperProfileRequiredLanguageProficiencyLanguageDropdown from './SuperProfileRequiredLanguageProficiencyLanguageDropdown';
import SuperProfileRequiredLanguageProficiencyProficiencyDropdown from './SuperProfileRequiredLanguageProficiencyProficiencyDropdown';

const SuperProfileRequiredLanguageProficiencyInput = ({ index, availableLanguages }) => {
  return (
    <div className="margin-bottom-0-5">
      <SuperProfileRequiredLanguageProficiencyLanguageDropdown index={index} availableLanguages={availableLanguages} />
      <SuperProfileRequiredLanguageProficiencyProficiencyDropdown index={index} />
    </div>
  );
};

export default SuperProfileRequiredLanguageProficiencyInput;
